import React from 'react';

import classnames from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import BiographyStyles from './Biography.module.scss';
import { IBiography } from './Biography.types';

const Biography = ({ biography, variant }: IBiography) => {
  return (
    <div
      className={classnames(BiographyStyles.biography, {
        [BiographyStyles[`biography_${variant}`]]: variant,
      })}
    >
      <img
        className={BiographyStyles.bioImg}
        src={biography.image.path}
        alt={biography.image.alt}
      />
      <div>
        <ReactMarkdown className={BiographyStyles.bioDescription} rehypePlugins={[rehypeRaw]}>
          {biography.body}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default Biography;
